/**
 * Handles string to Date conversions using UTC to avoid daylight saving offsets
 * @param dateString - Expected format: YYYY-MM-DD
 *
 */
var dateStringToUTCDate = function (dateString) {
    var date = new Date(dateString);
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
};
export default dateStringToUTCDate;
//# sourceMappingURL=dateStringToUTCDate.js.map